import StoredLayout from '../../layouts/StoredLayout'
import Tooltips from './Tooltips'
export default StoredLayout(Tooltips)



// WEBPACK FOOTER //
// ./src/ui-elements/tooltips/index.js